import { render, staticRenderFns } from "./PaymentReceipt.vue?vue&type=template&id=7ebb853c&scoped=true"
import script from "./PaymentReceipt.vue?vue&type=script&lang=js"
export * from "./PaymentReceipt.vue?vue&type=script&lang=js"
import style0 from "./PaymentReceipt.vue?vue&type=style&index=0&id=7ebb853c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebb853c",
  null
  
)

export default component.exports